export default {
  namespaced: true,
  state: () => ({
    source: [
      { value: 'saber', text: 'Saber' },
      { value: 'saber ME', text: 'Saber ME' },
      { value: 'saber AA', text: 'Saber AA' },
      { value: 'saber EU', text: 'Saber EU' },
      { value: 'jeem1', text: 'Jeem 1' },
      { value: 'sfda', text: 'SFDA' },
      { value: 'moph', text: 'MOPH' },
      { value: 'sfda-eg', text: 'SFDA EG' },
      { value: 'moiat', text: 'Moiat' },
      { value: 'sls', text: 'SLS' },
      { value: 'halal', text: 'Halal' },
    ],
  }),
  getters: {
    source: state => state.source,
  },
}
